/**
 *
 * app.js
 *
 * This is the entry file for the application, mostly just setup and boilerplate
 * code. Routes are configured at the end of this file!
 *
 */

import './commons/styles';
import { isIE } from './commons/utils/browser-utils';
import ieInjector from './commons/components/ieInjector';

if (isIE()) {
  ieInjector();
} else {
  // eslint-disable-next-line global-require
  require('./app');
}



// WEBPACK FOOTER //
// ./book/src/bootstrap.js